/**
 * defa.views.UserLoginForm
 * A view for logging in a user.
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/userLoginForm.jst.html';

const selectors     = {
	inputAll     : '[data-input]',
	inputEmail   : '[data-input=login-email]',
	inputPassword: '[data-input=login-password]',
	inputRemember: '[data-input=login-remember]',
	buttonForgot : '[data-click=user-forgot]',
	buttonCreate : '[data-click=user-create]',
};
const UserLoginForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		inputs  : selectors.inputAll,
		email   : selectors.inputEmail,
		password: selectors.inputPassword,
		remember: selectors.inputRemember,
		forgot  : selectors.buttonForgot,
		create  : selectors.buttonCreate,
	},
	
	events: {
		'click @ui.forgot': 'onClickForgot',
		'click @ui.create': 'onClickCreate',
	},
	
	templateContext: function () {
		return {
			email  : this.options.email,
			context: this.options.context || '',
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a user claims he's forgotten his password.
	 * @void
	 */
	onClickForgot: function ( event ) {
		event.preventDefault();
		this.trigger( 'nav', 'user:forgot' );
	},
	
	/**
	 * Triggers when a user requests to create a new account.
	 * @void
	 */
	onClickCreate: function ( event ) {
		event.preventDefault();
		this.trigger( 'nav', 'user:create' );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Submit the form through the model.
	 * @void
	 */
	submit: function () {
		this.model.authenticate( {
			email   : this.ui.email.val().trim(),
			password: this.ui.password.val().trim(),
			remember: this.ui.remember.is( ':checked' ),
		} );
	},
	
} );

export default UserLoginForm;